//
import { axios } from '@/utils/request'

export const authServerCostAcc = (data) => {
    return axios({
        url: 'https://www.51lss.com/studentWebApi.html?authServerCostAcc',
        method: 'POST',
        data
    })
}

// export const authServerCostAcc = (data) => {
//     return axios({
//         url: 'studentWebApi.html?authServerCostAcc',
//         method: 'POST',
//         data
//     })
// }
